/** Keep palette order stable: a tag's ID determines its colour, never its name. */
export const TAG_COLORS = [
  {
    light: '#35601f',
    dark: '#c0eb9c',
    lightBackground: '#daecc8',
    darkBackground: '#27361f',
  },
  {
    light: '#1e5681',
    dark: '#aad5f8',
    lightBackground: '#d7e6f0',
    darkBackground: '#1e3242',
  },
  {
    light: '#723682',
    dark: '#e9b8f4',
    lightBackground: '#eadbed',
    darkBackground: '#38243d',
  },
  {
    light: '#83441a',
    dark: '#f7c79b',
    lightBackground: '#f4e0ce',
    darkBackground: '#3e2c1f',
  },
  {
    light: '#125e4f',
    dark: '#9ae7d6',
    lightBackground: '#ceebe2',
    darkBackground: '#1c3732',
  },
  {
    light: '#6c5308',
    dark: '#f5db8b',
    lightBackground: '#f2eac2',
    darkBackground: '#38321a',
  },
] as const;

function tagPalette(tagId: string) {
  let hash = 2166136261;
  for (let index = 0; index < tagId.length; index += 1) {
    hash = Math.imul(hash ^ tagId.charCodeAt(index), 16777619);
  }
  return TAG_COLORS[(hash >>> 0) % TAG_COLORS.length];
}

export function tagColor(tagId: string, mode: 'light' | 'dark'): string {
  return tagPalette(tagId)[mode];
}

export function tagBackground(tagId: string, mode: 'light' | 'dark'): string {
  return tagPalette(tagId)[
    mode === 'light' ? 'lightBackground' : 'darkBackground'
  ];
}
